/* tslint:disable */

declare var Object: any;
export interface ERPitemConversionInterface {
  "id"?: number;
}

export class ERPitemConversion implements ERPitemConversionInterface {
  "id": number;
  constructor(data?: ERPitemConversionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPitemConversion`.
   */
  public static getModelName() {
    return "ERPitemConversion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPitemConversion for dynamic purposes.
  **/
  public static factory(data: ERPitemConversionInterface): ERPitemConversion{
    return new ERPitemConversion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPitemConversion',
      plural: 'ERPitemConversions',
      path: 'ERPitemConversions',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPitemConversion.ts